import { render, staticRenderFns } from "./InvBalance.vue?vue&type=template&id=13591c2e&"
import script from "./InvBalance.vue?vue&type=script&lang=js&"
export * from "./InvBalance.vue?vue&type=script&lang=js&"
import style0 from "./InvBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports